import React from 'react'
import { 
    Button, 
    Table, 
    Row, 
    Divider, 
    Popconfirm, 
    Modal, 
    Input, 
} from 'antd'
import { firestore } from '../../../service/firebase'
import './Notification.scss'
import EventService from '../../../service/event';

const { TextArea } = Input


export default class Notification extends React.Component {
    
    columns = [
        // { title: 'No', dataIndex: 'sort', key: 'sort' },
        { title: "Notification Title", dataIndex: 'title', key: 'title' },
        { title: "Content", dataIndex: 'content', key: 'content' },
        { title: "Created At", dataIndex: '', key: 'updated', render: (item) => {
            let updated = new Date(item['updated']['seconds'] * 1000);
            return (
                <span>{this.dateFormat(updated)}</span>
            )
        }},
        { title: 'Actions', dataIndex: '', key: 'action', render: (item) => {
            return (
                <span>
                    <a onClick={() => this.handleSend(item)}>Send Notification</a>
                    <Divider type="vertical" />
                    <a onClick={() => this.handleEdit(item)}>Edit</a>
                    <Divider type="vertical" />
                    <Popconfirm title="Are you sure delete?" onConfirm={() => this.handleDelete(item)} okText="Yes" cancelText="No">
                        <a>Delete</a>
                    </Popconfirm>
                </span>
            )
        }}
    ]

    dataList = []
    
    state = {
        title: '',
        content: '',
        showModal: false,
    }

    /*--------------------------------------------------------------*/
    /* Constructor */
    /*--------------------------------------------------------------*/

    constructor(props) {
        super(props)
        this.loadNotifications()
    }


    /*--------------------------------------------------------------*/
    /* Load data */
    /*--------------------------------------------------------------*/

    loadNotifications() {

        firestore.collection('Notifications')
        .orderBy("updated", "desc")
        .onSnapshot(snapshot => {
    
            snapshot.docChanges().forEach(change => {
    
                let data = change.doc.data()
    
                if(change.type === 'added') {

                    this.dataList.push(data)

                } else if(change.type === 'modified') {

                    this.dataList = this.dataList.map(item => {
                        if(item.id === data.id) {
                            return data
                        } else {
                            return item
                        }
                    })

                } else {

                    for(let i = 0; i < this.dataList.length; i++) {
                        let item = this.dataList[i]
                        if(item.id === data.id) {
                            this.dataList.splice(i, 1)
                            break
                        }
                    }

                }
            })
    
            this.forceUpdate()
        })
    
    }


    /*--------------------------------------------------------------*/
    /* Format functions */
    /*--------------------------------------------------------------*/

    dateFormat(date) {
        let year = this.numberFormat(date.getFullYear())
        let month = this.numberFormat(date.getMonth() + 1)
        let day = this.numberFormat(date.getDate())
        let hr = this.numberFormat(date.getHours())
        let min = this.numberFormat(date.getMinutes())

        return year + '/' + month + '/' + day + ' ' + hr + ':' + min
    }

    numberFormat(num) {
        return num > 9 ? num + '' : '0' + num
    }

    dateDetail(date) {
        if(date) {
            let dateStr = this.dateFormat(date.toDate())
            return (<div>{dateStr}</div>)
        } else {
            return (<div> - </div>)
        }
    }


    /*--------------------------------------------------------------*/
    /* Handle Functions */
    /*--------------------------------------------------------------*/

    handleAdd() {
        this.eventEdit = false
        this.setState({
            title: '',
            content: '',
            showModal: true,
        })
    }

    handleEdit(item) {
        this.eventEdit = true
        this.setState({
            id: item['id'],
            title: item['title'],
            content: item['content'],
            showModal: true,
        })
    }

    handleChange(key, value) {
        if(key === 'content') {
            if(value.length > 200) return
        }

        let state = this.state
        state[key] = value
        this.setState(state)
    }
    
    handleDelete(item) {
        firestore.collection('Notifications').doc(item.id).delete();
    }

    handleOK() {
        let state = this.state

        let id = state.id
        let ref

        if(!this.eventEdit) {
            ref = firestore.collection('Notifications').doc()
            id = ref.id
        } else {
            ref = firestore.collection('Notifications').doc(id)
        }

        let object = {
            id,
            title: state.title ? state.title : '',
            content: state.content ? state.content : '',
            updated: new Date(),
        }

        ref.set(object).then(() => {
            console.log("Saved new notification!")
            EventService.notification(object.title, object.content);
        })
        this.setState({showModal: false})
    }

    handleSend(object) {
        EventService.notification(object.title, object.content);
    }

    handleCloseModal() {
        this.setState({showModal: false})
    }

    /*--------------------------------------------------------------*/
    /* Render Functions */
    /*--------------------------------------------------------------*/
    
    render() {

        let { content } = this.state

        return (
            <div className="calendar-event">

                <Row style={{textAlign: 'right', padding: 10}}>
                    <Button type="primary" icon="plus" onClick={() => this.handleAdd()}>Notification</Button>
                </Row>

                <Table 
                    style={{margin: 10, background: 'white'}}
                    columns={this.columns}
                    rowKey={record => record.id}
                    dataSource={this.dataList} />

                <Modal
                    title={this.eventEdit ? 'Edit Notification' : "Add Notification"}
                    visible={this.state.showModal}
                    onOk={() => this.handleOK()}
                    onCancel={() => this.handleCloseModal()}>

                    <Row className="input-row">
                        <div className="input-label">Title</div>
                        <Input value={this.state.title} onChange={evt => this.handleChange('title', evt.target.value)} />
                    </Row>

                    <Row className="input-row">
                        <div className="input-label">Content ({content.length}/200)</div>
                        <TextArea autosize={{minRows: 3, maxRows: 9}} 
                            value={this.state.content} 
                            onChange={evt => this.handleChange('content', evt.target.value)} />
                    </Row>

                </Modal>

            </div>
        )
    }
}
